import { Field, ObjectType } from 'type-graphql'

export interface IAppInfo {
  appName: string
  version: string
  environment: string
}

@ObjectType()
export class AppInfo implements IAppInfo {
  @Field(() => String)
  appName: string

  @Field(() => String)
  version: string

  @Field(() => String)
  environment: string
}
